import { render } from "./DialogGRColor.vue?vue&type=template&id=ff051f08&scoped=true"
import script from "./DialogGRColor.vue?vue&type=script&lang=js"
export * from "./DialogGRColor.vue?vue&type=script&lang=js"

import "./DialogGRColor.vue?vue&type=style&index=0&id=ff051f08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff051f08"]])

export default __exports__